"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMInstructionBuilder = void 0;
const inversify_1 = require("inversify");
const VMOpCode_1 = require("../../enums/vm-transformers/VMOpCode");
const ICompilationContext_1 = require("../../interfaces/vm-transformers/ICompilationContext");
const VMJumpBuilder_1 = require("./VMJumpBuilder");
let VMInstructionBuilder = class VMInstructionBuilder {
    constructor(context) {
        this.context = context;
    }
    pushUndefined() {
        this.emit({ op: VMOpCode_1.VMOpCode.PUSH_UNDEFINED });
        return this;
    }
    pushNull() {
        this.emit({ op: VMOpCode_1.VMOpCode.PUSH_NULL });
        return this;
    }
    pushTrue() {
        this.emit({ op: VMOpCode_1.VMOpCode.PUSH_CONST, arg: this.context.constantPool.add(true) });
        return this;
    }
    pushFalse() {
        this.emit({ op: VMOpCode_1.VMOpCode.PUSH_CONST, arg: this.context.constantPool.add(false) });
        return this;
    }
    dup() {
        this.emit({ op: VMOpCode_1.VMOpCode.DUP });
        return this;
    }
    pop() {
        this.emit({ op: VMOpCode_1.VMOpCode.POP });
        return this;
    }
    swap() {
        this.emit({ op: VMOpCode_1.VMOpCode.SWAP });
        return this;
    }
    loadConst(value) {
        const index = this.context.constantPool.add(value);
        this.emit({ op: VMOpCode_1.VMOpCode.PUSH_CONST, arg: index });
        return this;
    }
    loadConstByIndex(index) {
        this.validateIndex(index, 'constant');
        this.emit({ op: VMOpCode_1.VMOpCode.PUSH_CONST, arg: index });
        return this;
    }
    loadArg(index) {
        this.validateIndex(index, 'parameter');
        this.emit({ op: VMOpCode_1.VMOpCode.LOAD_ARG, arg: index });
        return this;
    }
    loadLocal(index) {
        this.validateIndex(index, 'local variable');
        this.emit({ op: VMOpCode_1.VMOpCode.LOAD_LOCAL, arg: index });
        return this;
    }
    storeLocal(index) {
        this.validateIndex(index, 'local variable');
        this.emit({ op: VMOpCode_1.VMOpCode.STORE_LOCAL, arg: index });
        return this;
    }
    loadFromEnv(nameIndex) {
        this.validateIndex(nameIndex, 'environment name');
        this.emit({ op: VMOpCode_1.VMOpCode.LOAD_FROM_ENV, arg: nameIndex });
        return this;
    }
    loadFromEnvByName(name) {
        const nameIndex = this.context.constantPool.add(name);
        this.emit({ op: VMOpCode_1.VMOpCode.LOAD_FROM_ENV, arg: nameIndex });
        return this;
    }
    storeToEnv(nameIndex) {
        this.validateIndex(nameIndex, 'environment name');
        this.emit({ op: VMOpCode_1.VMOpCode.STORE_TO_ENV, arg: nameIndex });
        return this;
    }
    storeToEnvByName(name) {
        const nameIndex = this.context.constantPool.add(name);
        this.emit({ op: VMOpCode_1.VMOpCode.STORE_TO_ENV, arg: nameIndex });
        return this;
    }
    storeToCurrentEnv(nameIndex) {
        this.validateIndex(nameIndex, 'environment name');
        this.emit({ op: VMOpCode_1.VMOpCode.STORE_TO_CURRENT_ENV, arg: nameIndex });
        return this;
    }
    storeToCurrentEnvByName(name) {
        const nameIndex = this.context.constantPool.add(name);
        this.emit({ op: VMOpCode_1.VMOpCode.STORE_TO_CURRENT_ENV, arg: nameIndex });
        return this;
    }
    loadGlobal(nameIndex) {
        this.validateIndex(nameIndex, 'global name');
        this.emit({ op: VMOpCode_1.VMOpCode.GET_GLOBAL, arg: nameIndex });
        return this;
    }
    loadGlobalByName(name) {
        const nameIndex = this.context.constantPool.add(name);
        this.emit({ op: VMOpCode_1.VMOpCode.GET_GLOBAL, arg: nameIndex });
        return this;
    }
    storeGlobal(nameIndex) {
        this.validateIndex(nameIndex, 'global name');
        this.emit({ op: VMOpCode_1.VMOpCode.SET_GLOBAL, arg: nameIndex });
        return this;
    }
    storeGlobalByName(name) {
        const nameIndex = this.context.constantPool.add(name);
        this.emit({ op: VMOpCode_1.VMOpCode.SET_GLOBAL, arg: nameIndex });
        return this;
    }
    storeArg(index) {
        this.validateIndex(index, 'parameter');
        this.emit({ op: VMOpCode_1.VMOpCode.STORE_ARG, arg: index });
        return this;
    }
    storeToEnvConst(nameIndex) {
        this.validateIndex(nameIndex, 'environment name');
        this.emit({ op: VMOpCode_1.VMOpCode.STORE_TO_ENV_CONST, arg: nameIndex });
        return this;
    }
    storeToCurrentEnvConst(nameIndex) {
        this.validateIndex(nameIndex, 'environment name');
        this.emit({ op: VMOpCode_1.VMOpCode.STORE_TO_CURRENT_ENV_CONST, arg: nameIndex });
        return this;
    }
    getEnv() {
        this.emit({ op: VMOpCode_1.VMOpCode.GET_ENV, arg: 0 });
        return this;
    }
    createEnv() {
        this.emit({ op: VMOpCode_1.VMOpCode.CREATE_ENV, arg: 0 });
        return this;
    }
    restoreParentEnv() {
        this.emit({ op: VMOpCode_1.VMOpCode.RESTORE_PARENT_ENV, arg: 0 });
        return this;
    }
    declareTDZ(varName) {
        this.emit({ op: VMOpCode_1.VMOpCode.DECLARE_TDZ, arg: this.context.constantPool.add(varName) });
        return this;
    }
    add() {
        this.emit({ op: VMOpCode_1.VMOpCode.ADD });
        return this;
    }
    subtract() {
        this.emit({ op: VMOpCode_1.VMOpCode.SUB });
        return this;
    }
    multiply() {
        this.emit({ op: VMOpCode_1.VMOpCode.MUL });
        return this;
    }
    divide() {
        this.emit({ op: VMOpCode_1.VMOpCode.DIV });
        return this;
    }
    remainder() {
        this.emit({ op: VMOpCode_1.VMOpCode.MOD });
        return this;
    }
    exponentiation() {
        this.emit({ op: VMOpCode_1.VMOpCode.EXPONENT });
        return this;
    }
    negate() {
        this.emit({ op: VMOpCode_1.VMOpCode.NEG });
        return this;
    }
    increment() {
        this.emit({ op: VMOpCode_1.VMOpCode.INC });
        return this;
    }
    decrement() {
        this.emit({ op: VMOpCode_1.VMOpCode.DEC });
        return this;
    }
    equal() {
        this.emit({ op: VMOpCode_1.VMOpCode.EQ });
        return this;
    }
    strictEqual() {
        this.emit({ op: VMOpCode_1.VMOpCode.STRICT_EQ });
        return this;
    }
    notEqual() {
        this.emit({ op: VMOpCode_1.VMOpCode.NEQ });
        return this;
    }
    strictNotEqual() {
        this.emit({ op: VMOpCode_1.VMOpCode.STRICT_NEQ });
        return this;
    }
    lessThan() {
        this.emit({ op: VMOpCode_1.VMOpCode.LT });
        return this;
    }
    lessEqual() {
        this.emit({ op: VMOpCode_1.VMOpCode.LTE });
        return this;
    }
    greaterThan() {
        this.emit({ op: VMOpCode_1.VMOpCode.GT });
        return this;
    }
    greaterEqual() {
        this.emit({ op: VMOpCode_1.VMOpCode.GTE });
        return this;
    }
    logicalNot() {
        this.emit({ op: VMOpCode_1.VMOpCode.LOGICAL_NOT });
        return this;
    }
    bitwiseAnd() {
        this.emit({ op: VMOpCode_1.VMOpCode.BIT_AND });
        return this;
    }
    bitwiseOr() {
        this.emit({ op: VMOpCode_1.VMOpCode.BIT_OR });
        return this;
    }
    bitwiseXor() {
        this.emit({ op: VMOpCode_1.VMOpCode.BIT_XOR });
        return this;
    }
    bitwiseNot() {
        this.emit({ op: VMOpCode_1.VMOpCode.BIT_NOT });
        return this;
    }
    leftShift() {
        this.emit({ op: VMOpCode_1.VMOpCode.SHL });
        return this;
    }
    rightShift() {
        this.emit({ op: VMOpCode_1.VMOpCode.SHR });
        return this;
    }
    unsignedRightShift() {
        this.emit({ op: VMOpCode_1.VMOpCode.USHR });
        return this;
    }
    return() {
        this.emit({ op: VMOpCode_1.VMOpCode.RETURN });
        return this;
    }
    throw() {
        this.emit({ op: VMOpCode_1.VMOpCode.THROW });
        return this;
    }
    break() {
        const index = this.currentInstructionIndex();
        this.emit({ op: VMOpCode_1.VMOpCode.BREAK, target: 0 });
        return new VMJumpBuilder_1.VMJumpBuilder(this.context, index);
    }
    continue() {
        const index = this.currentInstructionIndex();
        this.emit({ op: VMOpCode_1.VMOpCode.CONTINUE, target: 0 });
        return new VMJumpBuilder_1.VMJumpBuilder(this.context, index);
    }
    tryStart(catchIndex, finallyIndex, endIndex) {
        this.emit({
            op: VMOpCode_1.VMOpCode.TRY_START,
            catchIndex,
            finallyIndex,
            endIndex
        });
        return this;
    }
    tryEnd() {
        this.emit({ op: VMOpCode_1.VMOpCode.TRY_END });
        return this;
    }
    catchStart(nameIndex) {
        this.emit({
            op: VMOpCode_1.VMOpCode.CATCH_START,
            arg: nameIndex
        });
        return this;
    }
    finallyStart() {
        this.emit({ op: VMOpCode_1.VMOpCode.FINALLY_START });
        return this;
    }
    finallyEnd() {
        this.emit({ op: VMOpCode_1.VMOpCode.FINALLY_END });
        return this;
    }
    jump() {
        const index = this.currentInstructionIndex();
        this.emit({ op: VMOpCode_1.VMOpCode.JUMP, target: 0 });
        return new VMJumpBuilder_1.VMJumpBuilder(this.context, index);
    }
    jumpIfFalse() {
        const index = this.currentInstructionIndex();
        this.emit({ op: VMOpCode_1.VMOpCode.JUMP_IF_FALSE, target: 0 });
        return new VMJumpBuilder_1.VMJumpBuilder(this.context, index);
    }
    jumpIfTrue() {
        const index = this.currentInstructionIndex();
        this.emit({ op: VMOpCode_1.VMOpCode.JUMP_IF_TRUE, target: 0 });
        return new VMJumpBuilder_1.VMJumpBuilder(this.context, index);
    }
    newObject() {
        this.emit({ op: VMOpCode_1.VMOpCode.NEW_OBJECT });
        return this;
    }
    objectSpread() {
        this.emit({ op: VMOpCode_1.VMOpCode.OBJECT_SPREAD });
        return this;
    }
    newArray() {
        this.emit({ op: VMOpCode_1.VMOpCode.NEW_ARRAY });
        return this;
    }
    arrayPush() {
        this.emit({ op: VMOpCode_1.VMOpCode.ARRAY_PUSH });
        return this;
    }
    arraySpreadPush() {
        this.emit({ op: VMOpCode_1.VMOpCode.ARRAY_SPREAD_PUSH });
        return this;
    }
    getProperty() {
        this.emit({ op: VMOpCode_1.VMOpCode.GET_PROP });
        return this;
    }
    getPropertyByName(propIndex) {
        this.validateIndex(propIndex, 'property');
        this.emit({ op: VMOpCode_1.VMOpCode.GET_PROP, arg: propIndex });
        return this;
    }
    getProp(propName) {
        const propIndex = this.context.constantPool.add(propName);
        this.emit({ op: VMOpCode_1.VMOpCode.GET_PROP, arg: propIndex });
        return this;
    }
    setProperty(propIndex) {
        this.validateIndex(propIndex, 'property');
        this.emit({ op: VMOpCode_1.VMOpCode.SET_PROP, arg: propIndex });
        return this;
    }
    setProp(propName) {
        const propIndex = this.context.constantPool.add(propName);
        this.emit({ op: VMOpCode_1.VMOpCode.SET_PROP, arg: propIndex });
        return this;
    }
    deleteProperty() {
        this.emit({ op: VMOpCode_1.VMOpCode.DELETE_PROP });
        return this;
    }
    getComputed() {
        this.emit({ op: VMOpCode_1.VMOpCode.GET_COMPUTED });
        return this;
    }
    getComputedOptional() {
        this.emit({ op: VMOpCode_1.VMOpCode.GET_COMPUTED_OPTIONAL });
        return this;
    }
    setComputed() {
        this.emit({ op: VMOpCode_1.VMOpCode.SET_COMPUTED });
        return this;
    }
    defineGetter(propNameIndex) {
        this.validateIndex(propNameIndex, 'property name');
        this.emit({ op: VMOpCode_1.VMOpCode.DEFINE_GETTER, arg: propNameIndex });
        return this;
    }
    defineSetter(propNameIndex) {
        this.validateIndex(propNameIndex, 'property name');
        this.emit({ op: VMOpCode_1.VMOpCode.DEFINE_SETTER, arg: propNameIndex });
        return this;
    }
    call(argCount) {
        this.emit({ op: VMOpCode_1.VMOpCode.CALL, arg: argCount });
        return this;
    }
    callNew(argCount) {
        this.emit({ op: VMOpCode_1.VMOpCode.NEW, arg: argCount });
        return this;
    }
    createFunction(bytecodeId) {
        const index = this.context.constantPool.add(bytecodeId);
        this.emit({ op: VMOpCode_1.VMOpCode.NEW_FUNC, arg: index });
        return this;
    }
    callMethod(argCount) {
        this.emit({ op: VMOpCode_1.VMOpCode.CALL_METHOD, arg: argCount });
        return this;
    }
    newFunc() {
        this.emit({ op: VMOpCode_1.VMOpCode.NEW_FUNC });
        return this;
    }
    arguments() {
        this.emit({ op: VMOpCode_1.VMOpCode.ARGUMENTS });
        return this;
    }
    typeof() {
        this.emit({ op: VMOpCode_1.VMOpCode.TYPEOF });
        return this;
    }
    typeofGlobal(nameIndex) {
        this.validateIndex(nameIndex, 'global name');
        this.emit({ op: VMOpCode_1.VMOpCode.TYPEOF_GLOBAL, arg: nameIndex });
        return this;
    }
    instanceof() {
        this.emit({ op: VMOpCode_1.VMOpCode.INSTANCEOF });
        return this;
    }
    in() {
        this.emit({ op: VMOpCode_1.VMOpCode.IN });
        return this;
    }
    this() {
        this.emit({ op: VMOpCode_1.VMOpCode.THIS });
        return this;
    }
    newTarget() {
        this.emit({ op: VMOpCode_1.VMOpCode.NEW_TARGET });
        return this;
    }
    spread() {
        this.emit({ op: VMOpCode_1.VMOpCode.SPREAD });
        return this;
    }
    await() {
        this.emit({ op: VMOpCode_1.VMOpCode.AWAIT });
        return this;
    }
    yield() {
        this.emit({ op: VMOpCode_1.VMOpCode.YIELD });
        return this;
    }
    yieldStar() {
        this.emit({ op: VMOpCode_1.VMOpCode.YIELD_STAR });
        return this;
    }
    getIterator() {
        this.emit({ op: VMOpCode_1.VMOpCode.GET_ITERATOR });
        return this;
    }
    iteratorNext() {
        this.emit({ op: VMOpCode_1.VMOpCode.ITERATOR_NEXT });
        return this;
    }
    iteratorDone() {
        this.emit({ op: VMOpCode_1.VMOpCode.ITERATOR_DONE });
        return this;
    }
    newRegex(pattern, flags) {
        const regexData = `${pattern}|||${flags}`;
        const dataIndex = this.context.constantPool.add(regexData);
        this.emit({
            op: VMOpCode_1.VMOpCode.NEW_REGEX,
            arg: dataIndex
        });
        return this;
    }
    createSymbol(hasDescription) {
        this.emit({
            op: VMOpCode_1.VMOpCode.SYMBOL,
            arg: hasDescription !== null && hasDescription !== void 0 ? hasDescription : -1
        });
        return this;
    }
    symbolFor(keyIndex) {
        this.emit({
            op: VMOpCode_1.VMOpCode.SYMBOL_FOR,
            arg: keyIndex
        });
        return this;
    }
    symbolKeyFor() {
        this.emit({
            op: VMOpCode_1.VMOpCode.SYMBOL_KEY_FOR,
            arg: 0
        });
        return this;
    }
    throwError(errorType, message) {
        const errorNameIndex = this.context.constantPool.add(errorType);
        this.loadGlobal(errorNameIndex);
        this.loadConst(message);
        this.loadConst(1);
        this.callNew(1);
        this.throw();
        return this;
    }
    emitUndefinedCheck() {
        this.dup();
        this.pushUndefined();
        this.strictEqual();
        return this.jumpIfFalse();
    }
    emitStaticMethodCall(globalName, methodName, argCount) {
        const globalIndex = this.context.constantPool.add(globalName);
        const methodIndex = this.context.constantPool.add(methodName);
        this.loadGlobal(globalIndex);
        this.dup();
        this.getPropertyByName(methodIndex);
        this.loadConst(argCount);
        this.callMethod(argCount);
        return this;
    }
    currentInstructionIndex() {
        return this.context.instructions.length;
    }
    emitRaw(instruction) {
        this.emit(instruction);
        return this;
    }
    emit(instruction) {
        this.context.instructions.push(instruction);
    }
    validateIndex(index, type) {
        if (!Number.isInteger(index) || index < 0) {
            throw new Error(`Invalid ${type} index: ${index}`);
        }
    }
};
exports.VMInstructionBuilder = VMInstructionBuilder;
exports.VMInstructionBuilder = VMInstructionBuilder = __decorate([
    (0, inversify_1.injectable)(),
    __metadata("design:paramtypes", [typeof (_a = typeof ICompilationContext_1.ICompilationContext !== "undefined" && ICompilationContext_1.ICompilationContext) === "function" ? _a : Object])
], VMInstructionBuilder);
